import { NumericFormat } from 'react-number-format';
import { clsx } from 'clsx';
import {
  DECIMAL_SEPARATOR, DEFAULT_DECIMAL_SCALE, PERCENT_SUFFIX, THOUSAND_SEPARATOR,
} from 'constants/general';
import { NUMBER_FORMATS } from 'constants/interfaces';

import type INumberField from './interfaces/INumberField';

import 'react-international-phone/style.css';
import styles from './scss/TextField.module.scss';

function NumberField({
  name, label, onChange, value, type,
  className, error, placeholder, icon,
  required, suffix, decimalScale = DEFAULT_DECIMAL_SCALE,
  disabled, hideTextError, allowNegative = true, max,
}: INumberField) {
  const classes = clsx(styles.root, className, {
    [styles.rootError]: error,
  });

  const wrapperClasses = clsx(styles.wrapper, {
    [styles.withIcon]: icon,
  });

  const numberSuffix = type === NUMBER_FORMATS.percent ? PERCENT_SUFFIX : '';

  const isAllowed = (values: { floatValue?: number }) => {
    const { floatValue } = values;
    if (floatValue === undefined) return true;
    if (max !== undefined && floatValue > max) return false;
    return true;
  };

  return (
    <div className={classes}>
      {label ? (
        <label htmlFor={name}>
          {required ? `${label}*` : label}
        </label>
      ) : null}
      <div className={wrapperClasses}>
        {icon ? (
          <div className={styles.icon}>
            {icon}
          </div>
        ) : null}

        <NumericFormat
          name={name}
          id={name}
          value={value}
          onValueChange={onChange}
          thousandSeparator={THOUSAND_SEPARATOR}
          decimalSeparator={DECIMAL_SEPARATOR}
          placeholder={placeholder}
          type="text"
          decimalScale={decimalScale}
          suffix={suffix || numberSuffix}
          disabled={disabled}
          allowNegative={allowNegative}
          isAllowed={isAllowed}
          allowLeadingZeros={false}
        />

      </div>
      {error && !hideTextError ? <p className={styles.error}>{error}</p> : null}
    </div>
  );
}

export default NumberField;
